<template>
    <div>
        <el-collapse accordion>
            <el-collapse-item>
                <template slot="title">设置权重</template>
                <el-form :model="vendData" ref="vendInfo">
                    <div class="simple-form" v-if="merchant == 'vend'">
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">年度故障率</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="AFR">
                                    <el-input-number v-model="vendData.AFR" :min="1" :max="100" :controls="false" ></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">设备可用性</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="DAY">
                                    <el-input-number v-model="vendData.DAY" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">平均完成时长</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="MMT">
                                    <el-input-number v-model="vendData.MMT" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">按期履约率</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="POS">
                                    <el-input-number v-model="vendData.POS" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
                <el-form :model="servData" ref="servInfo">
                    <div class="simple-form" v-if="merchant == 'serv'">
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">服务可用性</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="SAY">
                                    <el-input-number v-model="servData.SAY" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">总停工时长(台时)</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="CDT">
                                    <el-input-number v-model="servData.CDT" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">平均故障间隔(天)</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="AFID">
                                    <el-input-number v-model="servData.AFID" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">响应平均时长(分)</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="MREST">
                                    <el-input-number v-model="servData.MREST" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">到达平均时长(分)</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="ART">
                                    <el-input-number v-model="servData.ART" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group center">
                            <div class="form-label">
                                <label class="required">平均完成时长(时)</label>
                            </div>
                            <div class="form-value">
                                <el-form-item prop="MMT">
                                    <el-input-number v-model="servData.MMT" :min="1" :max="100" :controls="false" style="width: 100px"></el-input-number>
                                    <span>%</span>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
                <div>
                    <div class="swb-btn" @click="toCallback">计算</div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-eval-weight',
        desc: '评价权重',
        props: {
            // vend serv
            merchant: {
                type: String,
                default: 'vend'
            },
            callback: {
                type: Function
            }
        },
        data: function () {
            return {
                vendData: {
                    AFR: 100, // 年度故障率	Annual failure rate
                    DAY: 100, // 设备可用性  device availability
                    MMT: 100, // 平均维修时长 Mean maintenance time
                    POS: 100  // 按期履约率	Performance on schedule
                },
                servData: {
                    SAY: 100, // 服务可用性			Service availability
                    CDT: 100, // 总停工时长（台时）	Total downtime
                    AFID: 100, // 平均故障间隔(天）	Average failure interval days
                    MREST: 100, // 响应平均时长(分)	Mean response time
                    ART: 100, // 到达平均时长(分)	    Average arrival time
                    MMT: 100, // 平均维修时长（时）	Mean maintenance time
                }
            }
        },
        created(){
            if(this.merchant != 'vend' && this.merchant != 'serv') {
                console.error('merchant有效值为vend|serv');
            }
        },
        methods: {
            toCallback(){
                if(!isNoB(this.callback)) {
                    if(typeof this.callback == 'function') {
                        this.callback(this.getDlgResult());
                    }
                }
            },
            getDlgResult(){
                let result = {};
                result.type = 'info';
                if(this.merchant == 'vend') {
                    result.data = this.vendData;
                } else if(this.merchant == 'serv') {
                    result.data = this.servData;
                } else {
                    result.type = 'wran';
                    result.message = 'merchant有效值为vend|serv';
                }
                return result;
            }
        }
    }
</script>

<style>

    .el-collapse-item .el-collapse-item__header {
        background-color: #efefef;
        padding: 0 10px;
        margin-top: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/compo/retailer/EvalWeight.vue